import React from "react";
import "./PublicLayout.css";

/**
 * Shell for the app's first truly public, unauthenticated pages (online
 * admission apply/status, student portal) — no sidebar/user menu since
 * there's no logged-in session, unlike everything else in this app.
 */
export default function PublicLayout({ title, children }) {
  return (
    <div className="public-layout">
      <header className="public-header">
        <div className="brand">DGC</div>
        {title && <div className="public-header-title">{title}</div>}
      </header>
      <main className="public-content">{children}</main>
    </div>
  );
}
